import styled from 'styled-components';

import { CFG_ANIM } from '../../../../../../theme/configurator-tokens';

/** Fills the device screen with the static screenshot. Fades in on load, same as the
 *  live iframes it replaces here.
 *
 *  `$fit`: the laptop screenshot is wider than its screen cutout, so it CROPS from the
 *  top (`cover`) with no real loss (there is no "bottom" content to miss on a desktop
 *  hero shot). The phone capture's aspect ratio doesn't quite match its cutout (a full
 *  capture including the home-indicator area vs. the slightly shorter region left once
 *  our own decorative status-bar/home-indicator strips are drawn); `fill` stretches it
 *  to close that gap rather than crop content or leave a visible letterboxed margin.
 *  The devices render small enough that the resulting few-percent stretch isn't
 *  perceptible, and it becomes a no-op once the capture is regenerated at the matching
 *  aspect ratio.
 *
 *  Overscans by a couple percent (same principle as the laptop bezel PNG's own
 *  measured overscan in `frame-art.ts`): the screen cutout is a CSS percentage of the
 *  bezel PNG, which can round to a sub-pixel mismatch against the PNG's own alpha-
 *  channel edge at some render sizes, showing a hairline of whatever is behind the
 *  image. `FrameContent`'s `overflow: hidden` clips the overscanned edge instead of
 *  leaving that gap.
 *
 *  `width`/`height` are set EXPLICITLY (not left to resolve from `top`/`left` alone):
 *  a replaced element (an `<img>`) that is absolutely positioned with every inset side
 *  specified but width/height left `auto` falls back to its INTRINSIC size in that
 *  edge case, which both defeats the overscan and skips `object-fit` entirely (the
 *  image renders at its own native pixels, cropped wherever it overflows). */
export const ScreenshotImg = styled.img<{ $shown: boolean; $fit: 'cover' | 'fill' }>`
  position: absolute;
  top: -1%;
  left: -1%;
  width: 102%;
  height: 102%;
  object-fit: ${({ $fit }) => $fit};
  object-position: top center;
  opacity: ${({ $shown }) => ($shown ? 1 : 0)};
  transition: opacity ${CFG_ANIM.PREVIEW_FADE_MS}ms ease;
`;
